module.exports = __webpack_public_path__ + "static/media/icn_b3_m.ae655e09.svg";